(function() {
  var redirects = [
    {
      source: "https://stimara.com/collections/classic-clicky",
      destination: "https://stimara.com/collections/stimagz-classic"
    }
    // You can add more redirect objects here.
  ];

  var currentUrl = window.location.href;

  redirects.forEach(function(rule) {
    if (currentUrl.includes(rule.source)) {
      window.location.href = rule.destination;
    }
  });
})();
